"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _localization = require("@lt/localization");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _FeedbackMessengers = _interopRequireDefault(require("./components/FeedbackMessengers"));
var Feedback = function Feedback(props) {
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    isMobile = props.isMobile;
  return /*#__PURE__*/_react["default"].createElement(StyledFeedback, {
    className: className,
    $isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement(Title, null, _localization.i18n.t('headerMenu.feedback.title')), /*#__PURE__*/_react["default"].createElement(_FeedbackMessengers["default"], {
    isMobile: isMobile
  }));
};
var StyledFeedback = _styledComponents["default"].div.withConfig({
  displayName: "Feedback__StyledFeedback",
  componentId: "sc-14qyh2d-0"
})(["", " display:flex;flex-direction:column;"], function (_ref) {
  var $isMobile = _ref.$isMobile;
  return $isMobile ? 'padding-top: 25px;' : 'padding: 25px;';
});
var Title = _styledComponents["default"].div.withConfig({
  displayName: "Feedback__Title",
  componentId: "sc-14qyh2d-1"
})(["font-size:28px;text-align:center;font-weight:500;"]);
var _default = exports["default"] = Feedback;